import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const TRUST_API_URL = 'trust/admin/trusts-list/'

export const fetchUserTrusts = createAsyncThunk(
    'trust/fetchUserTrusts',
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            if (!token) {
                return;
            }

            const response = await axios.get(TRUST_API_URL, {
                params,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data?.data?.trusts;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to fetch trust list'
            );
        }
    }
);

const initialState = {
    trust_list: [],
    trust_loading: false,
    selected_trusts: [],
    error: null,
};

const trustSlice = createSlice({
    name: 'trust',
    initialState,
    reducers: {
        clearTrustList: (state) => {
            state.trust_list = {};
            state.error = null;
        },
        appendTrusts(state, action) {
            const { type, data } = action.payload;

            if (!state.selected_trusts) {
                state.selected_trusts = [];
            }

            if (type === 'individual') {
                const trustId = data;
                if (state.selected_trusts.includes(trustId)) {
                    state.selected_trusts = state.selected_trusts.filter(id => id !== trustId);
                } else {
                    state.selected_trusts.push(trustId);
                }
            } else if (type === 'all') {
                state.selected_trusts = data;
            }
        }




    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserTrusts.pending, (state) => {
                state.trust_loading = true;
                state.error = null;
            })
            .addCase(fetchUserTrusts.fulfilled, (state, action) => {
                state.trust_loading = false;
                state.trust_list = action.payload;
            })
            .addCase(fetchUserTrusts.rejected, (state, action) => {
                state.trust_loading = false;
                state.error = action.payload || 'Something went wrong';
                state.trust_list = []
            });
    },
});

export const { clearTrustList, appendTrusts } = trustSlice.actions;
export default trustSlice.reducer;
